(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-help-no-fit"]) return;
  try {
    

  const srClickHandler = (event) => {
     var message_body = "I would like to chat with a Rider Specialist."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }

  const srBikeClickHandler = (event) => {
     var message_body = "I am interested in a new bike."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }

  const srRideClickHandler = (event) => {
     var message_body = "I am interested in local bike groups and rides."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }

    const srServiceClickHandler = (event) => {
     var message_body = "I have a question about bike repair/services."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }
  
  const srFitClickHandler = (event) => {
    var message_body = "Hello, I am interested in bike fit services."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }

    const srFooterClickHandler = (event) => {
     var message_body = "I would like to chat with a Rider Specialist."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }


  
  document.getElementById("srTextLink").addEventListener("click", srClickHandler);
  console.log("clicking text link");

  document.getElementById("srBikeLink").addEventListener("click", srBikeClickHandler);
  console.log("Bike Link clicked");

  document.getElementById("srRideLink").addEventListener("click", srRideClickHandler);
  console.log("Ride Link clicked");

  document.getElementById("srServiceLink").addEventListener("click", srServiceClickHandler);
  console.log("Service Link clicked");

  document.getElementById("srFitLink").addEventListener("click", srFitClickHandler);
  console.log("Fit Link clicked");

  document.getElementById("srFooterLink").addEventListener("click", srFooterClickHandler);
  console.log("clicking text link");
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-help"]) return;
  try {
    

  const srClickHandler = (event) => {
     var message_body = "I would like to chat with a Rider Specialist."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }

  const srBikeClickHandler = (event) => {
     var message_body = "I am interested in a new bike."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }

  const srRideClickHandler = (event) => {
     var message_body = "I am interested in local bike groups and rides."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }

    const srServiceClickHandler = (event) => {
     var message_body = "I have a question about bike repair/services."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }
  
  const srFitClickHandler = (event) => {
    var message_body = "Hello, I am interested in bike fit services."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }

    const srFooterClickHandler = (event) => {
     var message_body = "I would like to chat with a Rider Specialist."
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }


  
  document.getElementById("srTextLink").addEventListener("click", srClickHandler);
  console.log("clicking text link");

  document.getElementById("srBikeLink").addEventListener("click", srBikeClickHandler);
  console.log("Bike Link clicked");

  document.getElementById("srRideLink").addEventListener("click", srRideClickHandler);
  console.log("Ride Link clicked");

  document.getElementById("srServiceLink").addEventListener("click", srServiceClickHandler);
  console.log("Service Link clicked");

  document.getElementById("srFitLink").addEventListener("click", srFitClickHandler);
  console.log("Fit Link clicked");

  document.getElementById("srFooterLink").addEventListener("click", srFooterClickHandler);
  console.log("clicking text link");
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-promo"]) return;
  try {
    
 const srPromoHandler = (event) => {
     var message_body = "I am interested in the Turbo Levo 4! Could I schedule a time and see what's available?"
     document.querySelector('[title="Webchat Widget"]').contentWindow.postMessage({ type: 'OPEN_WIDGET',  message_body}, '*')    
  }

   document.getElementById("srPromoLink").addEventListener("click", srPromoHandler);
  console.log("clicking text link");

  

  } catch(e) { console.error(e); }
})();
})();
